import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const IntelligentAgentsStructure = () => (
  <AIModuleSubtopic
    title="Intelligent Agents- Structure of Intelligent Agents"
    videos={[
      "https://www.youtube.com/embed/BkedAnQfJ_U",
      "https://www.youtube.com/embed/2iHaSVEadiI",
      "https://www.youtube.com/embed/4GsHzPsgq-A",
      "https://www.youtube.com/embed/Ov0kBRS1tmg"
    ]}
    takeaways={[
      { text: "learn the structure of each AI agent" },
      { text: "learn the applications of AI agents (scenario based question comes from this topic)" }
    ]}
    questions={[
      {
        text: "Consider an artificial agent learning to play chess, where the agent learns the game's rules and optimal moves through multiple plays and feedback from critics. Which type of agent would be most suitable for a chess-playing agent? Justify your answer. Also, briefly describe the agent architecture with a suitable diagram"
      },
      {
        text: "Consider the project developed by Google, codenamed Waymo. Waymo has successfully deployed self-driving cars with advanced sensors and implemented AI-based model algorithms in their decision-making process. These autonomous vehicles navigate the roads, making decisions based on percept history and real-time sensory input — the ability to make informed decisions based on historical data and real-time perceptual input received from the environments. Identify the most suitable model and explain how it fits this scenario where a decision has been made based on the perception of events that happened."
      },
      {
        text: "Explain the following: 1) Model-based Agent 2) Goal-based Agent"
      },
      {
        text: "Consider a vacuum cleaning agent with two locations blocks, i.e. block A and block B (see the figure given below). The environment would be dirty or clean blocks. The actions are right, left, suck, and no-op (no operation). A performance measure is given for the agent in which two points were given for each block cleaned, and one point was subtracted for each movement from one block to the other, and the block never became dirty once cleaned. i. Considering the agent as a simple (pure) reflex agent, describe the agent function in terms of performance measure. ii. Consider the performance measure and provide the agent function that would make the agent a rational agent.",
        image:"/ai_2.png"
      },
      {
        text: "Define an Agent. Discuss various agent architectures with suitable illustrations."
      },
      {
        text: "Illustrate the general model of the learning agent with a neat diagram."
      },
      {
        text: "Explain the model and utility-based agents with a diagram"
      },
      {
        text: "Explain the architecture of goal-based agents with a suitable diagram."
      },
      {
        text: "Compare and contrast the characteristics and capabilities of reflex agents, goal- based agents, utility-based agents, and learning agents in the context of artificial intelligence. Provide examples to illustrate each type."
      },
      {
        text: "A taxi company wants to optimize its drivers' routes to reduce fuel consumption, minimize travel time, and enhance customer satisfaction. List the challenges and plans in developing an AI system for a real time route optimization system that assists drivers in selecting the most efficient routes while considering dynamic factors like traffic, road conditions, toll plazas and weather conditions? Discuss with diagram the most suitable type of agent that can be used for this type of system."
      }
    ]}
    exampleVideos={[]}
  />
);

export default IntelligentAgentsStructure;
